<script>
import { EventPresenceElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-presence-element-mixin";
import TextElement from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import CountFormat from "%/dynamic-component-editor/options/count-format";
import HideWhenZero from "%/dynamic-component-editor/options/hide-when-zero";
import {
  DEFAULT_COUNT_FORMAT_LIVESTREAM,
  DEFAULT_COUNT_FORMAT_MEETING,
  formatPresenceCount,
  presenceCountForOccurrence,
} from "%/dynamic-component-editor/helpers/event-presence";

export default {
  name: "EventParticipantCount",
  elementPanelSettings: {
    displayIcon: "users",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Participant Count",
  },
  extends: TextElement,
  mixins: [EventPresenceElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  options: [CountFormat, HideWhenZero],
  computed: {
    isEditable() {
      return false;
    },
    presenceCount() {
      return presenceCountForOccurrence(this.entity, this.eventPresence, this.isLivestreamEvent);
    },
    countFormat() {
      const configured = String(this.getOptionValue(CountFormat) || "").trim();
      if (configured) {
        return configured;
      }

      return this.isLivestreamEvent ? DEFAULT_COUNT_FORMAT_LIVESTREAM : DEFAULT_COUNT_FORMAT_MEETING;
    },
    shouldShowText() {
      return Boolean(this.value) || this.editMode;
    },
    value() {
      return formatPresenceCount(this.presenceCount, this.countFormat, {
        hideWhenZero: Boolean(this.getOptionValue(HideWhenZero)) && !this.editMode,
      });
    },
  },
};
</script>
